import { useEffect, useState } from 'react';

export function useIsFullscreen(): {
  isFullscreen: boolean;
  fullscreenElement: Element | null;
} {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [fullscreenElement, setFullscreenElement] = useState<Element | null>(
    null
  );

  useEffect(() => {
    if (typeof document === 'undefined') return;

    function handleChange() {
      setIsFullscreen(!!document.fullscreenElement);
      setFullscreenElement(document.fullscreenElement);
    }

    document.addEventListener('fullscreenchange', handleChange);

    // Set initial state
    handleChange();

    return () => {
      document.removeEventListener('fullscreenchange', handleChange);
    };
  }, []);

  return { isFullscreen, fullscreenElement };
}
